import { IApiClient, IAuthHelper } from "@network/interfaces";
import { AuthRepository } from "@common/domain/repositories/AuthRepository";
import { getAuthSessionToken } from "@common/network/utils";
import { getStore } from "@common/utils/storeInjection";

export const oneDayTimePeriodInSecond = 86400;

class AuthenticationService implements IAuthHelper {
  private apiClient: IApiClient = undefined;

  public setAPIClient = (apiClient: IApiClient) => {
    this.apiClient = apiClient;
    this.apiClient.setAuthHelper(this);
    AuthRepository.resetApiClient(this.apiClient);
  };

  public getAccessToken = async (): Promise<string> => {
    const store = getStore();
    return store.getState().auth.authData?.sessionToken;
  };

  public getCurrentAccessToken = async (): Promise<string> =>
    getAuthSessionToken();
}

const authenticationService = new AuthenticationService();
export { authenticationService as AuthenticationService };
